import i18n from "@/plugins/vue-i18n";

import FocusGroup from "@/views/settings/focus-group/index";
import FocusGroupEdit from "@/views/settings/focus-group/edit/index.vue";

const focusGroup = [
  {
    path: "settings/focus-group",
    name: "FocusGroup",
    component: FocusGroup,
    meta: {
      title: i18n.t("title.focusGroup._"),
    },
  },
  {
    path: "settings/focus-group/:id/edit",
    name: "FocusGroupEdit",
    component: FocusGroupEdit,
    meta: {
      title: i18n.t("title.focusGroup.edit"),
    },
  },
];

export default focusGroup;
